import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { isEmpty } from '../../../helpers/common';
import { ButtonMainDiv, Icon, Title } from './styles';
interface DropdownButtonProps {
  iconName?: string;
  iconSize?: number;
  title?: string;
  isBorderRadius?: boolean;
  isActive?: boolean;
  variant?: 'no-border' | 'border' | 'hover-border';
  iconTone?: 'fill' | 'stroke';
  size?: 'small' | 'medium';
  isProjectTemplate?: boolean;
  iconViewBox?: string;
}
const DropdownButton = ({
  title,
  iconName,
  iconSize = 16,
  isBorderRadius = false,
  isActive = false,
  variant = 'border',
  iconTone = 'fill',
  size = 'medium',
  isProjectTemplate = false,
  iconViewBox = `0 0 ${iconSize} ${iconSize}`
}: DropdownButtonProps) => {
  return (
    <ButtonMainDiv
      isActive={isActive}
      isBorderRadius={isBorderRadius}
      variant={variant}
      iconTone={iconTone}
      isDifferentPadding={size === 'small' && isEmpty(title)}
      size={size}
      isProjectTemplate={isProjectTemplate}>
      {iconName && (
        <Icon>
          <SVGIcon name={iconName} width={`${iconSize}`} height={`${iconSize}`} viewBox={iconViewBox} />
        </Icon>
      )}
      {title && <Title>{title}</Title>}
    </ButtonMainDiv>
  );
};

export default DropdownButton;
